import { getServerRequest, postServerRequest, putServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const getExpediente = async (idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expediente/${idOficio}`;
    return await getServerRequest(url, config);
}

export const getDependencias = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/dependencias`;
    return await getServerRequest(url, config);
}
export const rutaPrueba = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: 'blob' };
    const url = `${httpURL}/archivo/documentoTransferencia`;
    return await getServerRequest(url, config);
}
export const getSeries = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/series`;
    return await getServerRequest(url, config);
}
export const getSubSeries = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/subseries`;
    return await getServerRequest(url, config);
}

export const addExpediente = async (idOficio, expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expediente/${idOficio}`;
    return await postServerRequest(url, expediente, config);
}

export const modificarExpediente = async (idOficio, expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/expediente/${idOficio}`;
    return await putServerRequest(url, expediente, config);
}


export const getEtiquetaService = async (idOficio,tipo,posicion) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: 'blob'};
    const url = `${httpURL}/expediente/etiqueta/${tipo}/${idOficio}?posicion=${posicion}`;
    return await getServerRequest(url, config);
}
export const getEtiquetaCajaService = async (idOficio,posicion) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: 'blob'};
    const url = `${httpURL}/expediente/etiquetaGrande/${idOficio}?posicion=${posicion}`;
    return await getServerRequest(url, config);
}

export const getCaratulaService = async (idOficio,tipo) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: 'blob'};
    const url = `${httpURL}/expediente/documento/${tipo}/${idOficio}`;
    return await getServerRequest(url, config);
}

export const agregarCajaService = async(data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/expediente/caja`;
    return await putServerRequest(url, data, config);
}